
<script>
	import listBase from '@_system/components/base/list.vue'
	import grabinvoice from './grabinvoice/index.vue'
	export default {
		extends: listBase,
		name: 'invoicecustomerIndex',
		render(h) {
			this.$slots.plug = [
				<vxe-modal v-model={this.grabinvoiceShow} width="1200" height="800" show-footer destroy-on-close  transfer lock-scroll={false}>
					<template slot="title">
						<div>抓取明细</div>
					</template>
					<template slot="default">
						<grabinvoice />
					</template>
					<template slot="footer">
						<vxe-button status="primary" content="返回" onClick={this.grabinvoiceBack}></vxe-button>
					</template>
				</vxe-modal>,
			]
			return listBase.render.call(this, h)
		},
		props: {
			foreingKey: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				moduleName: 'invoicecustomer',
				grabinvoiceShow:false
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			grabinvoice(){
				this.grabinvoiceShow = true
			},
			grabinvoiceBack(){
				this.grabinvoiceShow = false
			}
		},
		components: {
			grabinvoice
		}
	}
</script>
